export default {
  label: {
    noLogoSelected: 'Ningún logo seleccionado',
    logoTitle: 'Enlace de la imagen del encabezado',
    colorTitle: 'Color del encabezado',
    themeTitle: 'Tema',
    clearColor: 'Limpiar color',
    themeSwitch: 'Tema oscuro',
  },
};
